// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1cG0w","text":"SelectPayment_text__1Lk5X","title":"SelectPayment_title__1e--j","btn":"SelectPayment_btn__1gb7p"};